import { render } from "./projectsView.vue?vue&type=template&id=5c51f7e0"
import script from "./projectsView.vue?vue&type=script&lang=js"
export * from "./projectsView.vue?vue&type=script&lang=js"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__